import { render } from "./PopupModal.vue?vue&type=template&id=37e053e5&scoped=true"
import script from "./PopupModal.vue?vue&type=script&lang=js"
export * from "./PopupModal.vue?vue&type=script&lang=js"

import "./PopupModal.vue?vue&type=style&index=0&id=37e053e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e053e5"]])

export default __exports__